import React from "react";
import cn from "classnames";
import { Checked } from "components/icons/components/Checked";

export interface FlyerTypeData {
  dimensions: string;
  label: string;
  worth: string;
  type: string;
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  image?: string;
}

export const FlyerTypeCard = ({
  flyerTypeData,
  selectedFlyerType,
  onClick,
  variant = "primary",
  // Callers pass the FULL anchor (e.g. `postcardFormatOption-${type}`), not a
  // prefix to interpolate here. A prefix prop would put the dynamic part
  // first in this component's own template literal, which the copilot
  // anchors tripwire (an AST parse, not a text search) cannot resolve back
  // to a literal string — it would see an empty static prefix and either
  // miss the anchor or (worse) match it against anything.
  dataCy,
}: {
  flyerTypeData: FlyerTypeData;
  selectedFlyerType: string;
  onClick: () => void;
  variant?: "primary" | "secondary";
  dataCy: string;
}) => {
  const isPrimary = variant === "primary";
  const { Icon, dimensions, label, worth, type, image } = flyerTypeData;
  const selected = selectedFlyerType === type;

  return (
    <div
      // A custom dropdown with no roles is invisible to assistive tech and to
      // Copilot control mode alike — both look for role="option". Naming the
      // format also lets the agent pick one by text rather than by position.
      role="option"
      aria-selected={selected}
      data-cy={dataCy}
      className={cn(
        "box-border flex h-[78px] rounded-lg border border-solid bg-card p-3",
        isPrimary ? "mb-3 w-[229px] cursor-pointer" : "w-full cursor-default",
        selected ? "border-[#222336] dark:border-foreground" : "border-[#E2E2FC] dark:border-border"
      )}
      onClick={onClick}
    >
      <div className="relative flex h-full w-[30%] flex-[30%] items-center justify-center">
        {selected && <Checked className="absolute -left-2 -top-2" />}
        {image ? <img src={image} alt="" /> : <Icon />}
      </div>
      <div className="flex h-full flex-[70%] flex-col px-[15px] text-foreground">
        <span className="text-xs font-normal text-muted-foreground">{isPrimary ? dimensions : label}</span>
        <span className="text-base font-semibold text-foreground">{isPrimary ? label : dimensions}</span>
        <span className="text-xs font-normal text-[#4F5B94] dark:text-muted-foreground">{worth}</span>
      </div>
    </div>
  );
};
